<template>
  <aside class="w-1/6 bg-white shadow-md border-r border-gray-200 fixed top-0 left-0 h-full z-10">
    <div class="flex h-16 p-6 text-xl font-bold shadow-sm border-gray-200 text-pink-600 items-center justify-center">🌸 Bueno</div>
    <nav class="flex flex-col space-y-3 p-4">
      <RouterLink
        to="/account"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Текущие счета
      </RouterLink>

      <RouterLink
        to="/product-form"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Список товаров
      </RouterLink>

      <RouterLink
        to="/arrival"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Приход товара
      </RouterLink>

      <RouterLink
        to="/store"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Склад
      </RouterLink>
      
      <RouterLink
        to="/employee"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Сотрудники
      </RouterLink>
      
      <RouterLink
        to="/clients"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Клиенты
      </RouterLink>
      
      <RouterLink
        to="/sale"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Продажи
      </RouterLink>
      <RouterLink
        to="/reference-page"
        class="py-2 px-3 rounded-md hover:bg-pink-100"
        active-class="bg-pink-200 font-semibold"
      >
        Справочники
      </RouterLink>
    </nav>
  </aside>
</template>
